import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { NavbarComponent } from './shared/components/navbar/navbar.component';

// Áreas que possuem shell próprio (sidebar + header), incompatível com a navbar global
const OWN_LAYOUT_PREFIXES = ['/admin', '/organizer', '/portal'];

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, NavbarComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'radical-events-front';

  private router = inject(Router);

  hasOwnLayout = this.computeHasOwnLayout(this.router.url);

  constructor() {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.hasOwnLayout = this.computeHasOwnLayout(event.urlAfterRedirects);
      });
  }

  private computeHasOwnLayout(url: string): boolean {
    return OWN_LAYOUT_PREFIXES.some((prefix) => url.startsWith(prefix));
  }
}
